"use client";

import { useEffect, useRef, useState } from "react";
import { renderEmbedContent } from "./RenderEmbedClientSide.js";
const HEIGHT = 320;

function getContainerElement(containerId) {
  if (typeof window === "undefined" || !containerId) return null;
  return document.getElementById(containerId);
}

export function EmbedContentSidebarRenderer({
  body,
  containerId,
  getVideoAspect,
}) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setMounted(true);
    }, 200);
  }, []);
  const containerEl = useRef(getContainerElement(containerId));
  if (!mounted || typeof window === "undefined") return null;
  if (!containerEl.current) {
    containerEl.current = getContainerElement(containerId);
  }
  let lastRenderedPixel =
    containerEl.current?.getBoundingClientRect()?.top + window.scrollY ||
    window.innerHeight;

  return (
    <>
      {body.content
        .filter((content) => content?.attrs?.["data-id"])
        .filter((content) => content?.attrs?.side)
        .map((content) => {
          const el = document?.querySelector(
            `[data-id='${content.attrs["data-id"]}']`
          );
          const relativeTopPosition = el.getBoundingClientRect().top;
          const topPosition = relativeTopPosition + window.scrollY;

          const tempBottomPixel = lastRenderedPixel;

          const marginTop = Math.max(
            8,
            topPosition - tempBottomPixel - HEIGHT / 2
          );
          lastRenderedPixel = topPosition + HEIGHT;

          return (
            <div
              key={`embed-content-sidebar-${content.attrs["data-id"]}-${content.attrs.key}`}
              className="w-full"
              style={{ marginTop }}
            >
              {renderEmbedContent(content, getVideoAspect)}
            </div>
          );
        })}
    </>
  );
}
